<ng-container *ngIf="slugs.length < 1">
    <h1 class="mainTitle">
        <img
            ngSrc="assets/images/icons/help.svg"
            class="svgIcon"
            width="300"
            height="300"
            alt=""
        />
        {{ article.title }}
    </h1>

    <div class="mainArticles">
        <div *ngFor="let category of article.children" class="category">
            <img
                ngSrc="assets/images/icons/{{ category.icon }}"
                class="categoryIcon"
                width="300"
                height="300"
                alt=""
            />
            <h2>{{ category.title }}</h2>
            <div class="articles">
                <a routerLink="/support/{{ category.slug }}/{{ child.slug }}" *ngFor="let child of category.children" matRipple>
                    <img
                        ngSrc="assets/images/icons/{{ child.icon }}"
                        class="svgIcon"
                        width="300"
                        height="300"
                        alt=""
                    />
                    <span class="articleTitle">{{ child.title }}</span>
                    <mat-icon>east</mat-icon>
                </a>
            </div>
        </div>
    </div>

    <div class="extraHelp">
        <div class="dialogBox" *ngIf="stateService.getActiveUser()">
            <div class="extraHelpInfo">
                <mat-icon>password</mat-icon>
                <div>
                    <h2 i18n="@@support.pinCode">Your support PIN-code</h2>
                    <ng-container i18n="@@support.pinCodeInfo">
                        <p>Our support staff might request this PIN-code for security purposes.</p>
                    </ng-container>
                </div>
            </div>

            <p class="dialogActions">
                <button mat-flat-button color="primary" (click)="showPin()">
                    <mat-icon>password</mat-icon>
                    <ng-container i18n="@@support.showPin">Show my PIN</ng-container>
                </button>
            </p>
        </div>

        <div class="dialogBox">
            <div class="extraHelpInfo">
                <mat-icon>support_agent</mat-icon>
                <div>
                    <h2 i18n="@@support.contact">Contact us</h2>
                    <ng-container i18n="@@support.contactInfo">
                        <p>Can't find an answer in our help center? Our support staff will be happy to assist you!</p>
                    </ng-container>
                </div>
            </div>

            <p class="dialogActions">
                <a [routerLink]="'/' + navigationService.getRouteTranslation('contact')" mat-flat-button color="primary">
                    <mat-icon>mail</mat-icon>
                    <ng-container i18n="@@support.contact">Contact us</ng-container>
                </a>
            </p>
        </div>
    </div>
</ng-container>

<course-support-detail
    *ngIf="slugs.length > 0"
    [article]="article"
    [slugs]="slugs"
></course-support-detail>

<course-support-modals></course-support-modals>
